import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                close: 'close'
            }
        }

        setTimeout(() => {
            if (!this.checkCookie('popin_event')) {
                this.open();
                this.setCookie("popin_event", "Ok", 1); // Expries in 1 day
            }
        }, 500);
    }

    open() {
        this.el.classList.add('-opened');
        this.call('stop', 'Scroll');
    }

    close() {
        this.el.classList.remove('-opened');
        this.call('start', 'Scroll');
    }
    
    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    
    getCookie(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    checkCookie(cookieName) {
        let cookieValue = this.getCookie(cookieName);
        return (cookieValue == "Ok");
    }
}
